<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Actuals - Start Events Report</span><br/>
      <span style="font-style: italic; font-size: 18px">this report shows all driver/vehicle start event on the selected date.</span>
    </div>
    <div style="position: relative; font-weight: bold; font-size: 24px" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data()" :disabled="loading">Run Report</b-button>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      HOS Delta &nbsp;<b-form-select v-model="hos_threshold" :options="threshold_options" style="font-size: 20px; font-weight: bold; width:110px"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      Leave Delta &nbsp;<b-form-select v-model="leave_threshold" :options="threshold_options" style="font-size: 20px; font-weight: bold; width:110px"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      Filter Results&nbsp;<b-form-input style="width: 200px" v-model="booking_filter" placeholder="bookingID,vehicle,driver"/>
    </div>

    <div v-if="!loading">
      <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
        <div class="col" style="border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>
      </div>
    </div>

    <table v-if="!loading" width="100%" border="1" cellpadding="2">
      <tr>
        <th width="60px" @click="sort_numbers('bookingID')">Booking ID</th>
        <th width="60px" @click="sort_numbers('dayOfTrip')">Trip Day</th>
        <th width="60px" @click="sort_strings('vehicle')">Vehicle</th>
        <th width="60px" @click="sort_strings('driver')">Driver</th>
        <th width="60px" @click="sort_dates('plannedDriverStartTime')">Planned Start</th>
        <th width="60px" @click="sort_dates('actualClockInTime')">HOS</th>
        <th width="30px" @click="sort_numbers('hosDelta')">HOS - Start</th>
        <th width="60px" @click="sort_dates('plannedStartTime')">Planned Departure</th>
        <th width="60px" @click="sort_dates('actualIgnitionOnTime')">Ignition</th>
        <th width="60px" @click="sort_dates('actualLeaveTime')">Leave</th>
        <th width="30px" @click="sort_numbers('leaveDelta')">Leave - Ignition</th>
      </tr>
      <template v-for="item in items">
        <tr>
          <td align="center"><router-link style="font-weight: bold;" :to="{ path: '/actuals_tbn?booking_id=' + item.tbn_booking_hash }">{{ item.bookingID }}</router-link></td>
          <td align="center">{{ item.day_of_trip }}</td>
          <td align="center">{{ item.vehicle }}</td>
          <td align="center">{{ item.driver }} <a target="_blank" :href="item.driver_hos_link"><img style="margin: 0px 5px 5px 5px" src="/driver-icon.png"/></a></td>
          <td>{{item.plannedDriverStartTime | formatDateTimeSmall(item.timezone)}}</td>
          <td>{{item.actualClockInTime | formatDateTimeSmall(item.timezone)}}</td>
          <td v-if="item.hosDelta">{{item.hosDelta | units('m')}}</td>
          <td v-else>&nbsp;</td>
          <td>{{item.plannedStartTime | formatDateTimeSmall(item.timezone)}}</td>
          <td>{{item.actualIgnitionOnTime | formatDateTimeSmall(item.timezone)}}</td>
          <td>{{item.actualLeaveTime | formatDateTimeSmall(item.timezone)}}</td>
          <td v-if="item.leaveDelta">{{item.leaveDelta | units('m')}}</td>
          <td v-else>&nbsp;</td>
        </tr>
      </template>
    </table>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {api_url, get_tbn_actuals_start_events_report} from '../networking/tbn_apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'actuals_start_events_report_tbn',

  components: {
  },

  data() {
    return {
      booking_filter: '',
      items: [],
      summary: [],
      hos_threshold: null,
      leave_threshold: null,
      threshold_options: [
        { value: null, text: 'All' },
        { value: '10', text: '> 10m' },
        { value: '15', text: '> 15m' },
        { value: '30', text: '> 30m' },
        { value: '45', text: '> 45m' },
        { value: '60', text: '> 60m' },
        { value: '120', text: '> 120m' },
      ],
      loading: false,
      details_fromDate: justDate(moment().subtract(1, 'days')),

      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {

  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: {data = []}} = await get_tbn_actuals_start_events_report(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.filter_items()
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      this.items = this.items_full
      if (this.booking_filter)
        this.items = this.items.filter(item => (item.bookingID.indexOf(this.booking_filter) != -1 || (item.driver != null && item.driver.indexOf(this.booking_filter) != -1) || (item.vehicle != null && item.vehicle.indexOf(this.booking_filter) != -1)))
      if (this.hos_threshold)
        this.items = this.items.filter(item => (Math.abs(item.hosDelta) > this.hos_threshold))
      if (this.leave_threshold)
        this.items = this.items.filter(item => (Math.abs(item.leaveDelta) > this.leave_threshold))
    },
    sort_dates(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
    },
    hos_threshold(val) {
      this.filter_items()
    },
    leave_threshold(val) {
      this.filter_items()
    },
    booking_filter() {
      this.filter_items()
    },
  }
}
</script>

<style scoped>

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }

</style>
